import "./bootstrap"
import "../css/app.css"
import { createApp, h, DefineComponent } from "vue"
import { createPinia } from "pinia"
import { createInertiaApp, router } from "@inertiajs/vue3"
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers"
import { ZiggyVue } from "ziggy-js"
import ui from "@nuxt/ui/vue-plugin"
import UApp from "@nuxt/ui/components/App.vue"
// @ts-ignore
import * as Sentry from "@sentry/vue"

const appName = window.document.getElementsByTagName("title")[0]?.innerText || "Laravel"

const pinia = createPinia()

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob<DefineComponent>("./Pages/**/*.vue")),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(UApp, null, { default: () => h(App, props) }) })

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            environment: import.meta.env.APP_ENV,
        })

        app.use(plugin).use(ZiggyVue).use(pinia).use(ui).mount(el)
    },
    progress: {
        color: "#4B5563",
    },
})

router.on("flash", (event) => {
    const analyticsEvent = event.detail.flash.analyticsEvent

    if (typeof analyticsEvent === "string") {
        window.fathom?.trackEvent(analyticsEvent)
    }
})
